document.addEventListener("DOMContentLoaded", function () {

    const API_URL =
        "https://dialog.modish.no/api/cart-member-banner-attributes";

    const BANNER_ID = "cart-member-banner";

    const storeNameElement =
        document.getElementById("store_name");

    const themeSettings =
        window.ModishCartMemberBannerSettings || {};

    let bannerData = null;
    let lastContainer = null;


    /*
    |--------------------------------------------------------------------------
    | Store name
    |--------------------------------------------------------------------------
    */

    if (!storeNameElement) {
        console.error("Modish: #store_name not found.");
        return;
    }

    const storeName =
        storeNameElement.value?.trim();

    if (!storeName) {
        console.error("Modish: store name is empty.");
        return;
    }


    /*
    |--------------------------------------------------------------------------
    | Hide banner
    |--------------------------------------------------------------------------
    */

    function hideBanner() {

        const container =
            document.getElementById(BANNER_ID);

        if (!container) {
            return;
        }

        container.innerHTML = "";
        container.style.display = "none";
    }


    /*
    |--------------------------------------------------------------------------
    | Get banner settings
    |--------------------------------------------------------------------------
    */

    async function getBannerData() {

        /*
         * Disabled from Shopify
         */
        if (themeSettings.enabled === false) {
            return null;
        }


        /*
         * ==========================
         * SOURCE: SHOPIFY
         * ==========================
         */

        if (themeSettings.source === "shopify") {

            return {
                status: 1,

                header_text:
                    themeSettings.headerText || "",

                header_text_color:
                    themeSettings.headerTextColor || "#ffffff",

                frame_background_color:
                    themeSettings.frameBackgroundColor || "#d6959b",

                frame_border_color:
                    themeSettings.frameBorderColor || "#d6959b",

                content_text:
                    themeSettings.contentText || "",

                content_background_color:
                    themeSettings.contentBackgroundColor || "#ffffff",

                content_border_color:
                    themeSettings.contentBorderColor || "#ffffff",

                button_text:
                    themeSettings.buttonText || "REGISTRER/LOGG INN",

                button_url:
                    themeSettings.buttonUrl || "#",

                button_text_color:
                    themeSettings.buttonTextColor || "#000000",

                button_background_color:
                    themeSettings.buttonBackgroundColor || "#ffffff",

                button_border_color:
                    themeSettings.buttonBorderColor || "#000000",

                logged_in_button_text:
                    themeSettings.loggedInButtonText || "Mine medlemsfordeler",

                logged_in_button_url:
                    themeSettings.loggedInButtonUrl || "#",

                logged_in_button_text_color:
                    themeSettings.loggedInButtonTextColor || "#d4a3a8",

                logged_in_button_background_color:
                    themeSettings.loggedInButtonBackgroundColor || "#ffffff",

                logged_in_button_border_color:
                    themeSettings.loggedInButtonBorderColor || "#d4a3a8"
            };
        }


        /*
         * ==========================
         * SOURCE: MODISH
         * ==========================
         */

        try {

            const response = await fetch(API_URL, {

                method: "POST",

                headers: {
                    "Content-Type": "application/json"
                },

                body: JSON.stringify({
                    store_name: storeName
                })
            });


            if (!response.ok) {

                console.error(
                    "Modish Cart Member Banner API error:",
                    response.status
                );

                return null;
            }


            const data =
                await response.json();


            console.log(
                "Modish Cart Member Banner:",
                data
            );


            return data;

        } catch (error) {

            console.error(
                "Modish Cart Member Banner request failed:",
                error
            );

            return null;
        }
    }


    /*
    |--------------------------------------------------------------------------
    | Create button
    |--------------------------------------------------------------------------
    */

    function createButton({
        text,
        url,
        textColor,
        backgroundColor,
        borderColor
    }) {

        const button =
            document.createElement("a");

        button.textContent =
            text || "";

        button.href =
            url || "#";

        button.style.display =
            "block";

        button.style.width =
            "100%";

        button.style.boxSizing =
            "border-box";

        button.style.padding =
            "10px 20px";

        button.style.textAlign =
            "center";

        button.style.textDecoration =
            "none";

        // button.style.fontSize =
        //     "1.5rem";

        button.style.fontWeight =
            "500";

        button.style.color =
            textColor;

        button.style.backgroundColor =
            backgroundColor;

        button.style.border =
            `1px solid ${borderColor}`;

        return button;
    }


    /*
    |--------------------------------------------------------------------------
    | Render logged-out version
    |--------------------------------------------------------------------------
    */

    function renderLoggedOut(container) {

        /*
         * FRAME
         */

        const frame =
            document.createElement("div");

        frame.style.backgroundColor =
            bannerData.frame_background_color ||
            bannerData.frame_color ||
            "#d6959b";

        frame.style.border =
            `1px solid ${
                bannerData.frame_border_color ||
                bannerData.frame_color ||
                "#d6959b"
            }`;

        frame.style.padding =
            "18px";

        frame.style.boxSizing =
            "border-box";


        /*
         * HEADER
         */

        const header =
            document.createElement("div");

        header.textContent =
            bannerData.header_text || "";

        header.style.color =
            bannerData.header_text_color ||
            "#ffffff";

        header.style.fontSize =
            "22px";

        header.style.fontWeight =
            "500";

        header.style.marginBottom =
            "14px";


        /*
         * CONTENT
         */

        const content =
            document.createElement("div");

        /*
         * Your TinyMCE content is HTML:
         *
         * <p>...</p>
         *
         * This is coming from your own
         * Modish admin/API.
         */
        content.innerHTML =
            bannerData.content_text || "";

        content.style.backgroundColor =
            bannerData.content_background_color ||
            "#ffffff";

        content.style.border =
            `1px solid ${
                bannerData.content_border_color ||
                "#ffffff"
            }`;

        content.style.color =
            "#000000";

        content.style.padding =
            "14px";

        content.style.marginBottom =
            "14px";

        content.style.fontSize =
            "15px";

        content.style.lineHeight =
            "1.4";

        content.style.boxSizing =
            "border-box";


        /*
         * Remove default paragraph margin
         */
        content
            .querySelectorAll("p")
            .forEach(function (p) {

                p.style.margin =
                    "0";
            });


        /*
         * LOGIN / REGISTER BUTTON
         */

        const button =
            createButton({

                text:
                    bannerData.button_text,

                url:
                    bannerData.button_url,

                textColor:
                    bannerData.button_text_color ||
                    "#000000",

                backgroundColor:
                    bannerData.button_background_color ||
                    "#ffffff",

                borderColor:
                    bannerData.button_border_color ||
                    "#000000"
            });


        frame.appendChild(header);

        frame.appendChild(content);

        frame.appendChild(button);

        container.appendChild(frame);
    }


    /*
    |--------------------------------------------------------------------------
    | Render logged-in version
    |--------------------------------------------------------------------------
    */

    function renderLoggedIn(container) {

        const button =
            createButton({

                text:
                    bannerData.logged_in_button_text,

                url:
                    bannerData.logged_in_button_url,

                textColor:
                    bannerData.logged_in_button_text_color ||
                    "#d4a3a8",

                backgroundColor:
                    bannerData.logged_in_button_background_color ||
                    "#ffffff",

                borderColor:
                    bannerData.logged_in_button_border_color ||
                    "#d4a3a8"
            });


        container.appendChild(button);
    }


    /*
    |--------------------------------------------------------------------------
    | Render banner
    |--------------------------------------------------------------------------
    */

    function renderBanner() {

        const container =
            document.getElementById(BANNER_ID);


        if (!container) {
            return;
        }


        /*
         * No data / inactive
         */

        if (
            !bannerData ||
            Number(bannerData.status) !== 1
        ) {

            hideBanner();

            return;
        }


        /*
         * Clear previous content
         */

        container.innerHTML = "";

        container.style.display =
            "block";

        container.style.width =
            "100%";

        container.style.boxSizing =
            "border-box";

        


        /*
         * LOGGED IN
         */

        if (themeSettings.loggedIn === true) {

            renderLoggedIn(container);

            return;
        }


        /*
         * NOT LOGGED IN
         */

        renderLoggedOut(container);
    }


    /*
    |--------------------------------------------------------------------------
    | Initialize
    |--------------------------------------------------------------------------
    */

    async function init() {

        if (themeSettings.enabled === false) {

            hideBanner();

            return;
        }


        bannerData =
            await getBannerData();


        if (!bannerData) {

            hideBanner();

            return;
        }


        renderBanner();
    }


    /*
    |--------------------------------------------------------------------------
    | Dawn cart drawer observer
    |--------------------------------------------------------------------------
    |
    | Dawn may rebuild the cart drawer after:
    |
    | - Add product
    | - Remove product
    | - Quantity change
    |
    | Only render again when Shopify creates
    | a new #cart-member-banner element.
    |--------------------------------------------------------------------------
    */

    const observer =
        new MutationObserver(function () {

            const container =
                document.getElementById(
                    BANNER_ID
                );


            if (!container) {

                lastContainer = null;

                return;
            }


            if (
                container !== lastContainer &&
                bannerData
            ) {

                lastContainer =
                    container;

                renderBanner();
            }

        });


    observer.observe(
        document.body,
        {
            childList: true,
            subtree: true
        }
    );


    /*
    |--------------------------------------------------------------------------
    | Start
    |--------------------------------------------------------------------------
    */

    init();

});